import React, { useState, useEffect } from "react";
import { Col, Container, Row, Form, Input, Label, Button, Spinner } from "reactstrap";
import axios from "axios";
import { toast } from "react-toastify";
const Features = () => {
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [selectedBrands, setSelectedBrands] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [brands, setBrands] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [formData, setFormData] = useState({ name: "", company: "", email: "", mobile: "", location: "" });
    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/products`);
                const productsData = response.data.result;

                setProducts(productsData);
                setFilteredProducts(productsData);

                const uniqueBrands = [...new Set(productsData.map(product => product.brand_name))];
                const uniqueCategories = [...new Set(productsData.map(product => product.category_name))];
                setBrands(uniqueBrands);
                setCategories(uniqueCategories);
                setLoading(false);
            } catch (err) {
                console.error("Error fetching products:", err);
                setError("Failed to load products.");
                setLoading(false);
            }
        };

        fetchProducts();
    }, []);
    const handleBrandChange = (brand) => {
        setSelectedBrands((prev) =>
            prev.includes(brand) ? prev.filter((b) => b !== brand) : [...prev, brand]
        );
    };
    const handleCategoryChange = (category) => {
        setSelectedCategories((prev) =>
            prev.includes(category) ? prev.filter((c) => c !== category) : [...prev, category]
        );
    };
    useEffect(() => {
        setFilteredProducts(
            products.filter(
                (product) =>
                    (selectedBrands.length === 0 || selectedBrands.includes(product.brand_name)) &&
                    (selectedCategories.length === 0 || selectedCategories.includes(product.category_name)) &&
                    product.name.toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
    }, [selectedBrands, selectedCategories, searchTerm, products]);
    const toggleProductSelection = (product) => {
        setSelectedProducts((prev) => {
            return prev.some(p => p.product_id === product.product_id)
                ? prev.filter(p => p.product_id !== product.product_id)
                : [...prev, product];
        });
    };
    const removeProduct = (productId) => {
        setSelectedProducts((prev) => prev.filter(p => p.product_id !== productId));
    };
    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            selectedProducts: selectedProducts.map(p => ({ product_id: p.product_id, sku: p.sku, name: p.name })),
            ...formData
        };
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/quotation`, payload);
            setFormData({ name: "", company: "", email: "", mobile: "", location: "" });
            setSelectedProducts([]);
            toast.success("Request for quotation submitted successfully. Our team Will get in touch with you soon!");

        } catch (error) {
            console.error("Error sending request:", error);
            toast.error("Failed to send request for quote.");

        }
    };
    return (
        <React.Fragment>
            <section className="section bg-light py-5" id="features">
                <Container>
                    <Row className="align-items-center">
                        <div className="text-muted">
                            <div className="text-center ">
                                <h2 className="fw-bold mt-5" style={{ fontSize: "2rem", color: "#F15A29" }}>
                                    Products & Services
                                </h2>
                            </div>
                        </div>
                    </Row>
                </Container>
            </section>

            <div className={`bg-light px-5 ${loading ? "blur-effect" : ""}`}>
                <Row className="justify-content-center align-items-start">
                    <Col lg={2} md={4} sm={12} className="mb-4">
                        <div className="p-3 shadow-sm bg-white rounded">
                            <h5 className="fw-bold">Filters</h5>

                            <Form className="mb-3">
                                <Input
                                    type="text"
                                    placeholder="Search Products..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </Form>

                            <h6 className="fw-bold mt-3">Shop by Brand</h6>
                            {brands.length > 0 ? (
                                brands.map((brand, index) => (
                                    <div key={index} className="form-check">
                                        <Input
                                            type="checkbox"
                                            id={`brand-${brand}`}
                                            checked={selectedBrands.includes(brand)}
                                            onChange={() => handleBrandChange(brand)}
                                        />
                                        <Label for={`brand-${brand}`} className="ms-2">{brand}</Label>
                                    </div>
                                ))
                            ) : (
                                <p>No brands found.</p>
                            )}

                            <h6 className="fw-bold mt-3">Shop by Category</h6>
                            {categories.length > 0 ? (
                                categories.map((category, index) => (
                                    <div key={index} className="form-check">
                                        <Input
                                            type="checkbox"
                                            id={`category-${category}`}
                                            checked={selectedCategories.includes(category)}
                                            onChange={() => handleCategoryChange(category)}
                                        />
                                        <Label for={`category-${category}`} className="ms-2">{category}</Label>
                                    </div>
                                ))
                            ) : (
                                <p>No categories found.</p>
                            )}
                        </div>
                    </Col>

                    <Col lg={selectedProducts.length > 0 ? 7 : 10} md={8} sm={12} >
                        {loading ? (
                            <div className="d-flex justify-content-center w-100" style={{ minHeight: "300px" }}>
                                <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
                            </div>
                        ) : error ? (
                            <p>{error}</p>
                        ) : (
                            <Row>
                                {filteredProducts.length > 0 ? (
                                    filteredProducts.map((product) => (
                                        <Col lg={selectedProducts.length > 0 ? 4 : 3} md={6} sm={12} key={product.product_id} className="mb-4">
                                            <div className="card text-center shadow-sm p-3 bg-white rounded " style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px" }}>
                                                    <img
                                                        src={product.image_url}
                                                        alt={product.name}
                                                        className="card-img-top"
                                                        style={{ width: "80%", height: "auto", maxHeight: "100%", objectFit: "contain", borderRadius: "10px" }}
                                                    />
                                                </div>
                                                <div className="card-body" style={{ flex: "1", display: "flex", flexDirection: "column", justifyContent: "space-between", minHeight: "120px" }}>
                                                    <h5 className="card-title" style={{ minHeight: "40px", display: "flex", alignItems: "center", justifyContent: "center" }} >{product.name}</h5>
                                                    <Button style={{ backgroundColor: selectedProducts.some(p => p.product_id === product.product_id) ? "#31539d" : "#6691e7", color: "white" }} className="mt-2 border-0" onClick={() => toggleProductSelection(product)}>
                                                        {selectedProducts.some(p => p.product_id === product.product_id) ? "Selected for Quote" : "Request for Quote"}
                                                    </Button>
                                                </div>
                                            </div>
                                        </Col>
                                    ))
                                ) : (
                                    <div className="text-center">
                                        <p>No products found.</p>
                                    </div>
                                )}
                            </Row>
                        )}
                    </Col>
                    {selectedProducts.length > 0 && (
                        <Col lg={3} sm={12} style={{ position: "relative" }}>
                            <div className="p-3 shadow-sm bg-white rounded " style={{ width: "100%", maxWidth: "300px", right: 0 }}>
                                <div style={{ backgroundColor: 'rgb(102, 145, 231)', color: 'rgb(235, 98, 53)', padding: "10px", textAlign: "center" }}>
                                    <h5 style={{ color: "white" }}>Request for Quotation</h5>
                                </div>
                                <h6 className="fw-bold mt-3">Selected Products</h6>
                                <ol className="list-group mb-3">
                                    {selectedProducts.map((product, index) => (
                                        <li key={product.product_id} className="list-group-item d-flex justify-content-between align-items-center">
                                            {index + 1}. {product.name}
                                            <Button color="danger" size="sm" onClick={() => removeProduct(product.product_id)}>X</Button>
                                        </li>
                                    ))}
                                </ol>
                                <Form onSubmit={handleSubmit}>
                                    {Object.keys(formData).map((field) => (
                                        <div key={field}>
                                            <Label>{field.charAt(0).toUpperCase() + field.slice(1)}</Label>
                                            <Input type="text" name={field} value={formData[field]} onChange={handleInputChange} required />
                                        </div>
                                    ))}
                                    <Button type="submit" color="primary" className="mt-3 w-100">Send Request</Button>
                                </Form>
                            </div>
                        </Col>
                    )}
                </Row>
            </div>
        </React.Fragment >
    );
};
export default Features;

